import * as React from "react";
import * as ReactModal from "react-modal";

export default function OldDomainNotification(): JSX.Element {
    const url = "https://ib.metso.com";
    return (
        <ReactModal
            isOpen={true}
            contentLabel="Modal"
            styles={{}}
            defaultStyles={{}}
        >
            <div>
                IB Portal has been moved to a new domain:{" "}
                <a href={url}>{url}</a>. Please update your bookmarks and links!
                <div className="Modal__buttonGroup">
                    <a href={url}>
                        <button className="btn btn-primary float-end">
                            Go to IB Portal
                        </button>
                    </a>
                </div>
            </div>
        </ReactModal>
    );
}
